<template>
  <a
    :href="product.url"
    :class="b('', { variant })"
  >
    <e-picture
      v-if="image"
      :srcset="image.srcset"
      :alt="image.alt || image.title || product.name"
      :title="image.title"
      :fallback="image.fallback"
      :ratio="1"
      :sizes="pictureSizes"
      :placeholder="!image"
      loading="lazy"
      :class="b('image')"
    />
    <e-picture
      v-else
      :ratio="1"
      :sizes="pictureSizes"
      :placeholder="!image"
      loading="lazy"
      :class="b('image')"
      :alt="product.name"
    />
    <div :class="b('name')">
      {{ product.name }}
    </div>
  </a>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { PRODUCT_DISPLAY_PICTURE_SIZES } from '@/setup/globals';
  import ePicture from '@/elements/e-picture.vue';
  import type { Image } from '@/types/image';
  import { ProductBase } from '@/types/product';
  import { ImageSizes } from '@/types/sizes';

  export enum DesignVariants {
    List = 'list',
  }

  // type Setup = {};

  type Data = {
    pictureSizes: ImageSizes;
  };

  /**
   * Renders a related product item.
   */
  export default defineComponent({
    name: 'c-related-product',
    components: {
      ePicture,
    },

    props: {
      /**
       * The product to be displayed.
       */
      product: {
        type: Object as PropType<ProductBase>,
        required: true,
      },

      /**
       * Define the display variant.
       */
      variant: {
        type: String,
        default: DesignVariants.List,
        validator: (value: DesignVariants) => [DesignVariants.List].includes(value),
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    data(): Data {
      return {
        pictureSizes: PRODUCT_DISPLAY_PICTURE_SIZES,
      };
    },

    computed: {
      image(): Image | null {
        return this.product?.mainImage || this.product?.images?.[0] || null;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-related-product {
    $this: &;

    &--variant-list {
      @include mixins.hover-effect--default();

      display: grid;
      grid-template-columns: var(--theme-image-size--md) 1fr;
      align-items: center;
      margin-bottom: 1rem;
      gap: 0.5rem;

      @include mixins.media(sm) {
        &:hover {
          #{$this}__name {
            text-decoration: underline;
          }
        }
      }

      #{$this}__name {
        padding: 1rem;
      }
    }
  }
</style>
